module.exports = __webpack_public_path__ + "img/tpc-12.7a83233e.jpg";